import React, {FC, useEffect, useState} from 'react'
import {useLocation, useNavigate} from 'react-router-dom'
import {PageTitle} from '../../../_metronic/layout/core'
import { fetchData, toasterrormsg, toastsuccessmsg } from '../../../reusable';
import { ToastContainer } from 'react-toastify';
import { AddRestaurantHeader } from './AddRestaurantHeader';
import { Tr } from '../../../_metronic/i18n/Tr';

const AddRestaurantDetails: FC = () => {
    
    const t = Tr()
    const navigate=useNavigate()
    const categoryId = sessionStorage.getItem('categoryId');
    useEffect(() => {
        if (categoryId != '3') {
        navigate('../dashboard/');
        }
    }, [categoryId])
    const location = useLocation();
    const editRestaurantId = (location.state as any)?.restaurantId || '';
    const primaryLanguage = sessionStorage.getItem("primaryLanguage");
    
    var vendorId = "";
    const vendorData = sessionStorage.getItem("vendor");
    if (vendorData) {
        var vendor = JSON.parse(vendorData);
        vendorId = vendor.vendorId;
        
    } else {
        console.log("No vendor data found");
    }
    
    const [loading, setLoading] = useState(false)
    const [disable, setDisable] = useState(false);
    const [restaurantDetails, setRestaurantDetails] = useState([]);
    const [aboutInformationEN, setAboutInformationEN] = useState("");
    const [aboutInformationRU, setAboutInformationRU] = useState("");
    const [aboutInformationUZ, setAboutInformationUZ] = useState("");
    
    // set error state
    const [error,setError]=useState([{
        aboutInformationEN:'',
        aboutInformationRU:'',
        aboutInformationUZ:'',
    }])

    // remove validation function
    const removeError = (err:any) =>{
        var tmp = [...error] as any;
        tmp[0][err] = "";
        setError(tmp);
    }
    // validation function
    const validate = ()=>{

        var isValid = true;
        var errorTmp = [...error];
    
        if(primaryLanguage == "English"){

            if(aboutInformationEN.trim()=="" || aboutInformationEN.trim()==null || aboutInformationEN.trim() == undefined)
            {
              errorTmp[0].aboutInformationEN = t('About Information Is Required');
              isValid = false;
            }
        }else if(primaryLanguage == "Russian"){
            if(aboutInformationRU.trim()=="" || aboutInformationRU.trim()==null || aboutInformationRU.trim() == undefined)
            {
              errorTmp[0].aboutInformationRU = t('About Information Is Required');
              isValid = false;
            }
        }else if(primaryLanguage == "Uzbek"){
            if(aboutInformationUZ.trim()=="" || aboutInformationUZ.trim()==null || aboutInformationUZ.trim() == undefined)
            {
              errorTmp[0].aboutInformationUZ = t('About Information Is Required');
              isValid = false;
            }
        }
        
        setError(errorTmp);
        return isValid;
    }
    // add hotel details call
    const addRestaurantDetailApi = async () =>{
        
        if(validate()){
            
            setDisable(true)
            setLoading(true);
            let param = {
                restaurantId:editRestaurantId,
                en_aboutInformation:aboutInformationEN,
                ru_aboutInformation:aboutInformationRU,
                uz_aboutInformation:aboutInformationUZ,
            }
            var res=await fetchData("public/addRestrauntPropertyDetails",param)
            if(res.status=="200")
            {
                toastsuccessmsg(t("Details Added Successfully!"))
                const state = {
                    restaurantId:editRestaurantId
                }
                setTimeout(() => {
                    navigate("../addrestaurantmenu/",{ state });
                    setDisable(false)
                }, 1500);
            }
            else
            {
                toasterrormsg(res.message)
                setDisable(false)

            }
        }
    }
    //   restaurant list api call
    const restaurantDetailApiCall = async () => {

        var param = {
            'vendorId': vendorId,
            'restaurantId':editRestaurantId
        }
        var res = await fetchData("public/restaurantDetail", param)

        if (res.status == "200") {
            var restaurantData = res.data;
            setRestaurantDetails(restaurantData);
            setAboutInformationEN(restaurantData[0]['en_aboutInformation'])
            setAboutInformationRU(restaurantData[0]['ru_aboutInformation'])
            setAboutInformationUZ(restaurantData[0]['uz_aboutInformation'])
        }
        else {
            toasterrormsg(res.message)
        }
    }
    useEffect(() => {

        if (editRestaurantId != "") {
            restaurantDetailApiCall();
        }
    }, [])
      
  return (
    <>
    <ToastContainer/>
      <PageTitle breadcrumbs={[]}>{editRestaurantId != "" ? t('Edit Property Details') : t('Add Property Details')}</PageTitle>
      <AddRestaurantHeader restaurantId={editRestaurantId}/>
      <div className="d-flex flex-column flex-column-fluid">
        {/* <!--begin::Content--> */}
        <div id="kt_app_content" className="app-content flex-column-fluid">
            {/* <!--begin::Form--> */}
            <div className="form d-flex flex-column flex-lg-row">
                {/* <!--begin::Main column--> */}
                <div className="d-flex flex-column flex-row-fluid gap-7 gap-lg-10">
                    {/* <!--begin::Tab content--> */}
                    <div className="tab-content">
                        {/* <!--begin::Tab pane--> */}
                        <div className="tab-pane fade show active" id="kt_ecommerce_add_product_general" role="tab-panel">
                            <div className="d-flex flex-column">
                                {/* <!--begin::General options--> */}
                                <div className="card card-flush py-4">
                                    {/* <!--begin::Card header--> */}
                                    <div className="card-header d-flex">
                                        {/* <!--begin::Card title--> */}
                                        <div className="card-title">
                                            <h2>{t('Property Details')}</h2>
                                        </div>
                                        {/* <!--end::Card title--> */}
                                        <div className='d-flex align-items-center w-200px w-sm-300px flex-column'>
                                            {
                                                restaurantDetails.length != 0 ? (
                                                    <>
                                                    {
                                                        restaurantDetails.map((completedSteps:any,index:any) => {
                                                            var percentage = 0;
                                                            if(completedSteps['completedSteps']['basicInfo']){
                                                                percentage = 10;
                                                            }
                                                            if(completedSteps['completedSteps']['location']){
                                                                percentage = 20;
                                                            }
                                                            if(completedSteps['completedSteps']['propertyDetail']){
                                                                percentage = 40;
                                                            }
                                                            if(completedSteps['completedSteps']['menu']){
                                                                percentage = 50;
                                                            }
                                                            if(completedSteps['completedSteps']['photos']){
                                                                percentage = 60;
                                                            }
                                                            if(completedSteps['completedSteps']['facilitiesAndServices']){
                                                                percentage = 70;
                                                            }
                                                            if (completedSteps['completedSteps']['availability']) {
                                                                percentage = 80;
                                                            }
                                                            if(completedSteps['completedSteps']['policies']){
                                                                percentage = 90;
                                                            }
                                                            if(completedSteps['completedSteps']['financeAndLegal']){
                                                                percentage = 100;
                                                            }
                                                            return (
                                                                <React.Fragment key={index}>
                                                                    <div className='d-flex justify-content-between w-100 mt-auto'>
                                                                        <span className='fw-bold fs-6'>{t('Completion')}</span>
                                                                        <span className='fw-bolder fs-6'>{percentage}%</span>
                                                                    </div>
                                                                    <div className='h-5px mx-3 w-100 bg-light mb-3'>
                                                                        <div
                                                                        className='bg-success rounded h-5px'
                                                                        role='progressbar'
                                                                        style={{width: `${percentage}%`}}
                                                                        ></div>
                                                                    </div>
                                                                </React.Fragment>
                                                            )
                                                        })
                                                    }
                                                    </>
                                                ) : (
                                                    <>
                                                        <div className='d-flex justify-content-between w-100 mt-auto'>
                                                            <span className='fw-bold fs-6'>{t('Completion')}</span>
                                                            <span className='fw-bolder fs-6'>0%</span>
                                                        </div>
                                                        <div className='h-5px mx-3 w-100 bg-light mb-3'>
                                                            <div
                                                            className='bg-success rounded h-5px'
                                                            role='progressbar'
                                                            style={{width: '0%'}}
                                                            ></div>
                                                        </div>
                                                    </>
                                                )
                                            }
                                        </div>
                                    </div>
                                    {/* <!--end::Card header--> */}
                                    {/* <!--begin::Card body--> */}
                                    <div className="card-body pt-10">
                                        {/* <!--begin::Input group--> */}
                                        {
                                            primaryLanguage == "English" && (
                                                <>        
                                                    <div className="row">
                                                        <div className="col-lg-4 my-3">
                                                            {/* <!--begin::Label--> */}
                                                            <label className="required fs-4 form-label">{t('About Information (English)')}</label>
                                                            {/* <!--end::Label--> */}
                                                            {/* <!--begin::Input--> */}
                                                            <textarea name="aboutInformationEN" className="form-control mb-2" placeholder={("About Information")} cols={30} rows={4} onChange={(e) => { setAboutInformationEN(e.target.value);removeError("aboutInformationEN"); }} value={aboutInformationEN}></textarea>
                                                            {/* <!--end::Input--> */}
                                                            <div className='text-danger fw-bold'>{error[0].aboutInformationEN}</div>
                                                        </div>
                                                        <div className="col-lg-4 my-3">
                                                            {/* <!--begin::Label--> */}
                                                            <label className="fs-4 form-label">{t('About Information (Russian)')}</label>
                                                            {/* <!--end::Label--> */}
                                                            {/* <!--begin::Input--> */}
                                                            <textarea name="aboutInformationRU" className="form-control mb-2" placeholder={("About Information")} cols={30} rows={4} onChange={(e) => { setAboutInformationRU(e.target.value) }} value={aboutInformationRU}></textarea>
                                                            {/* <!--end::Input--> */}
                                                        </div>
                                                        <div className="col-lg-4 my-3">
                                                            {/* <!--begin::Label--> */}
                                                            <label className="fs-4 form-label">{t('About Information (Uzbek)')}</label>
                                                            {/* <!--end::Label--> */}
                                                            {/* <!--begin::Input--> */}
                                                            <textarea name="aboutInformationUZ" className="form-control mb-2" placeholder={("About Information")} cols={30} rows={4} onChange={(e) => { setAboutInformationUZ(e.target.value) }} value={aboutInformationUZ}></textarea>
                                                            {/* <!--end::Input--> */}
                                                        </div>
                                                    </div>
                                                </>
                                            )
                                        }
                                        {
                                            primaryLanguage == "Russian" && (
                                                <>        
                                                    <div className="row">
                                                        <div className="col-lg-4 my-3">
                                                            {/* <!--begin::Label--> */}
                                                            <label className="required fs-4 form-label">{t('About Information (Russian)')}</label>
                                                            {/* <!--end::Label--> */}
                                                            {/* <!--begin::Input--> */}
                                                            <textarea name="aboutInformationRU" className="form-control mb-2" placeholder={t("About Information")} cols={30} rows={4} onChange={(e) => { setAboutInformationRU(e.target.value);removeError("aboutInformationRU"); }} value={aboutInformationRU}></textarea>
                                                            <div className='text-danger fw-bold'>{error[0].aboutInformationRU}</div>
                                                            {/* <!--end::Input--> */}
                                                        </div>
                                                        <div className="col-lg-4 my-3">
                                                            {/* <!--begin::Label--> */}
                                                            <label className="fs-4 form-label">{t('About Information (English)')}</label>
                                                            {/* <!--end::Label--> */}
                                                            {/* <!--begin::Input--> */}
                                                            <textarea name="aboutInformationEN" className="form-control mb-2" placeholder={t("About Information")} cols={30} rows={4} onChange={(e) => { setAboutInformationEN(e.target.value)}} value={aboutInformationEN}></textarea>
                                                            {/* <!--end::Input--> */}
                                                        </div>
                                                        <div className="col-lg-4 my-3">
                                                            {/* <!--begin::Label--> */}
                                                            <label className="fs-4 form-label">{t('About Information (Uzbek)')}</label>
                                                            {/* <!--end::Label--> */}
                                                            {/* <!--begin::Input--> */}
                                                            <textarea name="aboutInformationUZ" className="form-control mb-2" placeholder={t("About Information")} cols={30} rows={4} onChange={(e) => { setAboutInformationUZ(e.target.value) }} value={aboutInformationUZ}></textarea>
                                                            {/* <!--end::Input--> */}
                                                        </div>
                                                    </div>
                                                </>
                                            )
                                        }
                                        {
                                            primaryLanguage == "Uzbek" && (
                                                <>        
                                                    <div className="row">
                                                        <div className="col-lg-4 my-3">
                                                            {/* <!--begin::Label--> */}
                                                            <label className="required fs-4 form-label">{t('About Information (Uzbek)')}</label>
                                                            {/* <!--end::Label--> */}
                                                            {/* <!--begin::Input--> */}
                                                            <textarea name="aboutInformationUZ" className="form-control mb-2" placeholder={t("About Information")} cols={30} rows={4} onChange={(e) => { setAboutInformationUZ(e.target.value);removeError("aboutInformationUZ"); }} value={aboutInformationUZ}></textarea>
                                                            <div className='text-danger fw-bold'>{error[0].aboutInformationUZ}</div>
                                                            {/* <!--end::Input--> */}
                                                        </div>
                                                        <div className="col-lg-4 my-3">
                                                            {/* <!--begin::Label--> */}
                                                            <label className="fs-4 form-label">{t('About Information (Russian)')}</label>
                                                            {/* <!--end::Label--> */}
                                                            {/* <!--begin::Input--> */}
                                                            <textarea name="aboutInformationRU" className="form-control mb-2" placeholder={t("About Information")} cols={30} rows={4} onChange={(e) => { setAboutInformationRU(e.target.value)}} value={aboutInformationRU}></textarea>
                                                            {/* <!--end::Input--> */}
                                                        </div>
                                                        <div className="col-lg-4 my-3">
                                                            {/* <!--begin::Label--> */}
                                                            <label className="fs-4 form-label">{t('About Information (English)')}</label>
                                                            {/* <!--end::Label--> */}
                                                            {/* <!--begin::Input--> */}
                                                            <textarea name="aboutInformationEN" className="form-control mb-2" placeholder={t("About Information")} cols={30} rows={4} onChange={(e) => { setAboutInformationEN(e.target.value)}} value={aboutInformationEN}></textarea>
                                                            {/* <!--end::Input--> */}
                                                        </div>
                                                    </div>
                                                </>
                                            )
                                        }
                                        {/* <!--end::Input group--> */}
                                    </div>
                                    {/* <!--end::Card body--> */}
                                </div>
                                {/* <!--end::Pricing--> */}
                            </div>
                        </div>
                        {/* <!--end::Tab pane--> */}
                    </div>
                    {/* <!--end::Tab content--> */}
                    <div className="d-flex justify-content-end">
                        {/* <!--begin::Button--> */}
                        <button type="button" disabled={disable}  className="btn btn-primary" onClick={addRestaurantDetailApi}>
                            <span className="indicator-label">{t('Next')}</span>
                            {loading && (
                                <span className="spinner-border spinner-border-sm mx-2" role="status" aria-hidden="true"></span>
                            )}
                        </button>
                        {/* <!--end::Button--> */}
                    </div>
                </div>
                {/* <!--end::Main column--> */}
            </div>
            {/* <!--end::Form--> */}
        </div>
        {/* <!--end::Content--> */}
    </div>
    </>
  )
}

export {AddRestaurantDetails}
